export default "__VITE_ASSET__4ef5a6a8__"